interface StatCardProps {
  label: string;
  value: string | number;
  icon: string;
  colorClass: string;
  bgClass: string;
}

export default function StatCard({ label, value, icon, colorClass, bgClass }: StatCardProps) {
  return (
    <div className="bg-background-50 border border-background-200/70 rounded-lg p-4 flex items-center gap-4 hover:border-background-300/60 transition-colors cursor-pointer">
      <div className={`w-10 h-10 rounded-lg ${bgClass} flex items-center justify-center shrink-0`}>
        <i className={`${icon} ${colorClass} text-lg`}></i>
      </div>
      <div className="min-w-0">
        <p className="text-xs text-foreground-500 mb-0.5 whitespace-nowrap">{label}</p>
        <p className="text-lg font-semibold text-foreground-900 font-heading">{value}</p>
      </div>
    </div>
  );
}